var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopLeftStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 147,
    viewBox: "0 0 118 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.8 141.682C82.8 138.973 80.604 136.777 77.895 136.777C75.186 136.777 72.99 138.973 72.99 141.682C72.99 144.391 75.186 146.587 77.895 146.587C80.604 146.587 82.8 144.391 82.8 141.682Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07602 103.691C6.07602 102.013 4.71602 100.653 3.03802 100.653C1.36002 100.653 0 102.013 0 103.691C0 105.369 1.36002 106.729 3.03802 106.729C4.71502 106.729 6.07602 105.369 6.07602 103.691Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.155 103.691C117.155 102.013 115.795 100.653 114.117 100.653C112.439 100.653 111.079 102.013 111.079 103.691C111.079 105.369 112.439 106.729 114.117 106.729C115.794 106.729 117.155 105.369 117.155 103.691Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.32 -1.52588e-05C88.9978 -1.52588e-05 90.358 1.36015 90.358 3.03799C90.358 4.71584 88.9978 6.07599 87.32 6.07599C85.6421 6.07599 84.282 4.71584 84.282 3.03799C84.282 1.36015 85.6421 -1.52588e-05 87.32 -1.52588e-05Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.92 26.347C25.821 20.742 30.216 16.348 35.82 15.447C30.215 14.546 25.821 10.151 24.92 4.54698C24.019 10.152 19.624 14.546 14.02 15.447C19.625 16.348 24.019 20.743 24.92 26.347Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftStars);
export default __webpack_public_path__ + "static/media/top-left-stars.120df1711907af355b507775e732e35f.svg";
export { ForwardRef as ReactComponent };